import {useState} from 'react'
import { Heart, Edit, User, RotateCw } from 'react-feather';
import UserMenuEditPersonalData from './UserMenuEditPersonalData';
import MyFavs from '../shared/MyFavs';
import { UserMenuNNHeader } from './UserMenuNNHeader';

interface UserSignedInNNProps {
  onLogout: () => void
  user: any
}

const UserSignedInNN = ({ onLogout, user }: UserSignedInNNProps) => {
  const [editModePersonalData, setEditModePersonalData] = useState(false);

  return (
    <div className="user-menu">
      {!editModePersonalData &&
      <>
        <UserMenuNNHeader onLogout={onLogout} />
        <ul className="user-menu__list">
          <li className="user-menu__list-item">
            <User />
            <div className="user-menu__list-item-wrapper">
              <div className="user-menu__list-item-title">
                <p>Persönliche Daten</p>
                <button type="button" onClick={() => {setEditModePersonalData(!editModePersonalData)}}>
                  <Edit />
                </button>
              </div>

              <div className="user-menu__list-item-content">
                <p className="user-menu__list-item-info">{user?.userName} {user?.userSurname}</p>
                <p className="user-menu__list-item-info">{user?.userEmail}</p>
              </div>
            </div>
          </li>

          {/* <li className="user-menu__list-item">
            <RotateCw />
            <div className="user-menu__list-item-wrapper">
              <div className="user-menu__list-item-title">
                <p>Mein Abonnement</p>
                <Edit />
              </div>

              <div className="user-menu__list-item-content">
                <p className="user-menu__list-item-info">{user?.userComment}</p>
                <p className="user-menu__list-item-info">gebucht am 14.04.2023</p>
              </div>
            </div>
          </li> */}
        </ul>
        </>
      }
      {editModePersonalData && 
      <div>
        <UserMenuEditPersonalData onBack={() => {setEditModePersonalData(false)}}/>
      </div>}
    </div>
  )
}

export default UserSignedInNN